export default "__VITE_ASSET__BCfTHbpG__"